import * as S from '@effect/schema/Schema'
import MarketingListMemberSchema from 'features/ListBuilder/infra/repo/schema/MarketingListMemberSchema'

export const GETMembersByPageSchema = S.Struct({
  count: S.Number,
  items: S.Array(MarketingListMemberSchema),
})

export type GETMembersByPageSchema = S.Schema.Type<typeof GETMembersByPageSchema>
